import { SharePayload } from "@shared/type/ShareType";
import { apiFetch } from "@shared/api/api";
import { global } from "@shared/libs/Global";

type IssueLike = {
  no_issue?: string;
  st_issue?: string;
  dc_title?: string;
};

/**
 * 이슈 상세(SN_SFA_ISSUE_REG_002)를 여는 공유 링크를 생성한다.
 * no_issue는 필수로 포함해야 링크 복원이 가능하다.
 */
export const buildIssueShareLink = async (
  issue: IssueLike,
  opts?: { menuName?: string; menuPath?: string }
): Promise<string | null> => {
  if (!issue?.no_issue) return null;

  const payload: SharePayload = {
    version: 1,
    menuId: "SN_SFA_ISSUE_REG_002",
    menuName: opts?.menuName ?? "ISSUE MANAGEMENT",
    menuPath: opts?.menuPath ?? "SFA > 이슈관리 > ISSUE MANAGEMENT",
    cd_module: "SFA",
    nm_file: "SN_SFA_ISSUE_REG_002",
    shareType: "telegram_issue_reg",
    createdAt: new Date().toISOString(),
    state: {
      search: {
        no_issue: issue.no_issue ?? "",
        st_issue: issue.st_issue ?? "",
        dc_title: issue.dc_title ?? "",
      },
      params: {
        no_issue: issue.no_issue ?? "",
      },
    },
  };

  const user = global.getState().userInfo;
  try {
    const res = await apiFetch<{ shareId: string }>("/api/share", {
      method: "POST",
      body: {
        payload,
        ttlDays: 7,
        cdFirm: user?.cd_firm,
        cdUser: user?.cd_user,
        cdMenu: payload.menuId,
      } as any,
      headers: {
        "X-TENANT-ID": user?.tenant_id || "DEFAULT",
      },
    });
    const shareId = res.data?.shareId;
    if (!shareId) return null;
    const origin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "";
    return `${origin}/share/${shareId}`;
  } catch (error) {
    console.error("issue share link create failed", error);
    return null;
  }
};
